import React, { useEffect, useState } from "react";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useAuth } from "../../../../context/AuthContext";
import classes from "./AddInformationManagement.module.css";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import { env } from "../../../../constants/env";
import QuestionSection from "../../../ui/QuestionSection/QuestionSection";
import { useCertification } from "../../../../hooks/useCertification";

const questionSets = [
  {
    render: (onAnswerChange, answers, editable) => (
      <>
        <QuestionSection
          number="9.1"
          title="Procedure and/or Process for Reporting and Release of Results"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content: "Defining report format;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Medium (electronic or paper based);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Reviewing of patient results;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Communication of alert, urgent and critical patient results;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Release of results and reports by authorized persons;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Amendments of results and reports;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Issue of amended reports;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Reporting of results performed by a referral laboratory;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Identification of the referral laboratory;",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Retention and maintenance of patient results",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="9.2"
          title="Test Result Reporting System"
          questions={[
            {
              content: (
                <>
                  Are test results legible, technically verified, and confirmed
                  against patient identity?
                  <br />
                  Note: Paper-based reports must be written in ink and have
                  documentation of review and verification. Evidence of
                  documentation of verification must be available
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="9.3"
          title="Testing Personnel"
          questions={[
            {
              content:
                "Is the person authorizing the release of the result identified on the result report or other records (paper- or electronic-based)?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="9.4"
          title="Requirements for Reports"
          questions={[
            {
              content:
                "Does the laboratory report contain at least the following:",
              hideOptions: true,
            },
            {
              content:
                "Defining the validation or verification protocol (including the authorization for the intended use);",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Identification of the laboratory issuing the report;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Identification of all examinations performed by a referral laboratory or part of a research or development program;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Patient identification, location, date of primary sample collection (and time, relevant to patient care), date of issue on every page of the report;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Name of the requester (user);",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Identification of examination method used, where relevant, and including, where possible and necessary, harmonized (electronic) identification of the measurand and measurement principle;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Type of primary sample and any specific information necessary to describe the sample",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Provisional reports;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Reporting of result in SI units, when applicable;",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Biological reference intervals, clinical decision limits, likelihood ratios;",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Presence of space for interpretation or comments of results, when applicable;",
              number: "k",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Indication of critical results;",
              number: "l",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Identification of the person(s) reviewing and authorizing the release of the report;",
              number: "m",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Date and time of the report;",
              number: "n",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Page number to total number of pages (e.g., ‘Page 1 of 5’);",
              number: "o",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Clear identification of revisions, including reference to the date and patient identity on the original report, and user notification of the revision, when issuing revised reports;",
              number: "p",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Presence on revised record of time and date of change and name
                  of the person responsible for the change;
                  <br />
                  Note: When the reporting system cannot capture amendments,
                  changes or alterations, a record of such shall be kept
                </>
              ),
              number: "q",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Presence of original report entry in the record
                  <br />
                  Note: Applicable to paper- and electronic-based systems
                </>
              ),
              number: "r",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="9.5"
          title="Analytic System / Method Tracing"
          questions={[
            {
              content: (
                <>
                  Are test results traceable to the equipment used for testing
                  when more than one instrument is in use for the same test?
                  <br />
                  Note: There must be traceability of sample results, including
                  proficiency testing results, to a specific analytical system
                  or method
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="9.6"
          title="Procedure and/or Process for Laboratory Information System (LIS) (computerised or non-computerised)"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following?
                  <br />
                  Note: ‘Information systems’ includes the management of data
                  and information contained in both computer and
                  non-computerized systems. Some of the requirements may be more
                  applicable to computer systems than to non-computerized
                  systems. Computerized systems can include those integral to
                  the functioning of laboratory equipment and stand-alone
                  systems using generic software, such as word processing,
                  spreadsheet and database applications that generate, collate,
                  report and archive patient information and reports
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Verification of the LIS on installation and after every upgrade;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Definition of authorities and responsibilities for management and use of the LIS;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Patient confidentiality;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Maintenance and troubleshooting of the LIS;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Back-up and storage of non-computerized system;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Ongoing checks of calculations used to generate results;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Data transfers checks (interface between testing systems and LIS) for protection and security of the system against external and internal access and tampering;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Automated selection, review, release and reporting of results",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="9.7"
          title="Archived Data Laboratory and Storage"
          questions={[
            {
              content: (
                <>
                  Are archived results (paper or data-storage media) properly
                  labelled and stored in a secure location accessible only to
                  authorized personnel?
                  <br />
                  Note: All patient data, paper, and external storage devices
                  must be retained as per the laboratory’s retention policy and
                  should be stored in a safe and access-controlled environment
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="9.8"
          title="Authorities and Responsibilities for Information Management"
          questions={[
            {
              content: (
                <>
                  Has the laboratory designated authorities and responsibilities
                  for the management and use of the LIS, both paper- and
                  electronic-based, including access, maintenance and
                  modifications that may affect patient care?
                  <br />
                  Note 1: ‘Information systems’ includes the management of data
                  and information contained in both computer and
                  non-computerized systems. Some of the requirements may be more
                  applicable to computer systems than to non-computerized
                  systems. Computerized systems can include those integral to
                  the functioning of laboratory equipment and standalone systems
                  using generic software, such as word processing, spreadsheet
                  and database applications that generate, collate, report and
                  archive patient information and reports.”
                  <br />
                  Note 2: Authorities and responsibilities may be defined in the
                  authority matrix, job description, etc Is the following in
                  place and implemented?
                </>
              ),
              hideOptions: true,
            },
            {
              content: "Controlled access to patient data and information;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Controlled access to enter patient data and examination results;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Controlled access to modifying patient data or examination results;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Controlled access to the release of examination results and reports",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="9.9"
          title="Verification of Electronic Laboratory Information System"
          questions={[
            {
              content:
                "Note: The laboratory must perform verification of the system after upgrades and to ensure previously stored patient results have not been affected",
              hideOptions: true,
            },
            {
              content:
                "Has the system been validated and or verified before implementation and version upgrades?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are ongoing system checks available for correct transmission, calculation and storage of results and records?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are there records to check the functioning of the interface of the LIS to other systems (e.g., analyser’s, hospital information system)?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="9.10"
          title="Records of Maintenance of the Laboratory Information System"
          questions={[
            {
              content:
                "Note 1: If the LIS is maintained offsite, records of maintenance must be readily available. The laboratory should include the LIS as part of their internal audit.",
              hideOptions: true,
            },
            {
              content:
                "Records of regular service by authorized and trained personnel;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Records of system failures with documented appropriate root cause analysis, corrective actions and verification;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Records that the system is operated in an environment recommended by the supplier for optimal functioning;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: (
                <>
                  Evidence that the laboratory has implemented a process to
                  ensure the protection and security of the LIS
                  <br />
                  Note 1: If the LIS is maintained offsite, records of
                  maintenance must be readily available. The laboratory should
                  include the LIS as part of their internal audit
                </>
              ),
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
      </>
    ),
  },
];

const AddInformationManagement = () => {
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const { user, token } = useAuth();
  const [status, setStatus] = useState(null);

  const { labId, questionnaireId } = useParams(); // ✅ get questionnaireId too

  const editable = questionnaireId ? status === "Not Attached" : true;

  const {
    formData: answers,
    handleChange: handleAnswerChange,
    handleDone,
    editMode,
    loading,
    isFetching,
  } = useCertification(
    "Information Management", // section
    {}, // initialAnswers
    questionnaireId // questionnaireId (optional)
  );

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };

  return (
    <div
      className={`${classes.wrapper} ${!editMode ? classes.fromParams : ""}`}
    >
      <div
        className="d-flex align-items-center gap-2 mb-4"
        onClick={() => navigate(-1)}
        role="button"
      >
        <IoIosArrowRoundBack size={35} />
        <h2 className="m-0">
          Section 09: Information Management {questionnaireId && "(Editing)"}
        </h2>
      </div>

      {isFetching || loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {questionSets[currentSet].render(
            handleAnswerChange,
            answers,
            editMode
          )}

          {editMode && (
            <CommonFooter
              handlePrevious={handlePrevious}
              handleCancel={() => navigate(-1)}
              handleNext={handleNext}
              handleDone={handleDone}
              questionSets={questionSets}
              currentSet={currentSet}
              cancelText="Cancel"
              doneText={
                questionnaireId ? "Update Assessment" : "Submit Assessment"
              }
            />
          )}
        </>
      )}
    </div>
  );
};

export default AddInformationManagement;
